/* eslint-disable */
import ko from 'knockout';
import _ from 'underscore';
import ko_schema from '@bingads-webui-component-legacy/ko-schema/index';
var i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/campaign-creation-advanced');
var viewModel = function (options) {
  var self = this;
  self.options = options || ({});
  ko_schema.properties(self);
  self.adGroups = ko.observableArray([]);
  self.numCreated = 0;
  self.maxAdGroups = _.isFinite(options.maxAdGroups) ? options.maxAdGroups : 100;
  self.isValid = ko.observable(true);
  self.isKeywordPlannerEnabled = ko.observable(false);
  self.isMixedModeCampaignCreation = options.isMixedModeCampaignCreation;
  self.isForVNext = options.isForVNext;
  self.hasChanges = ko.observable(false);
  self.hasMaxAdGroups = ko.computed(function () {
    return self.adGroups().length >= self.maxAdGroups;
  });
  self.showAdGroupLimitError = ko.computed(function () {
    return self.hasMaxAdGroups() && self.maxAdGroups > 1;
  });
  self.isDuplicateName = function (name, index) {
    var isDuplicate = false;
    if (_.size(name.trim()) > 0) {
      _.each(self.adGroups(), function (adGroup) {
        var comparisonName = adGroup.ko_model.Name().toLowerCase();
        if (_.isString(comparisonName) && comparisonName === name.toLowerCase() && adGroup.options.index !== index) {
          isDuplicate = true;
        }
      });
    }
    return isDuplicate;
  };
  self.checkDuplicates = function () {
    _.each(self.adGroups(), function (adGroup) {
      var isDuplicated = self.isDuplicateName(adGroup.ko_model.Name(), adGroup.options.index);
      adGroup.ko_model.isNameDuplicate(isDuplicated);
    });
  };
  self.getUniqueName = function (name) {
    var uniqueName = name;
    var index = 1;
    while (self.isDuplicateName(uniqueName, -1) && index <= self.maxAdGroups) {
      index++;
      uniqueName = name + ' ' + index;
    }
    return uniqueName;
  };
  self.removeAdGroup = function (toRemove) {
    self.adGroups.remove(toRemove);
  };
  self.addAdGroup = function (toAdd) {
    self.adGroups.push(toAdd);
  };
  self.showLandingPage = ko.observable(true);
  self.keywordPlannerTopValue = ko.observable();
  self.keywordPlannerTopValuePixel = ko.computed(function () {
    var offset;
    if (self.isMixedModeCampaignCreation && self.isForVNext) {
      offset = 160;
    } else if (self.showLandingPage()) {
      offset = 100;
    } else {
      offset = 25;
    }
    return self.keywordPlannerTopValue() + offset + 'px';
  });
  self.isWaitingForSaveResponse = ko.computed(function () {
    return _.every(self.adGroups(), function (adGroup) {
      return !adGroup.ko_model.isWaitingForSaveResponse();
    });
  });
  self.hasOneAdGroup = ko.computed(function () {
    return _.size(self.adGroups()) <= 1;
  });
};
export default viewModel;

